<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <el-button class="new-btn" @click="newOrder">
            <i class="el-icon-plus"></i>
            添加
          </el-button>
          <div class="right-search">
            <!-- <el-select class="right-select" v-model="reType">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select> -->
            <el-input
              class="search-input"
              placeholder="请输入搜索内容"
              v-model="search_name"
              :header-cell-style="getRowClass"
              prefix-icon="el-icon-search" @keyup.enter.native="searchName">
            </el-input>
          </div>
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="code"
            label="规程代码">
          </el-table-column>
          <el-table-column
            prop="name"
            label="规程名称">
          </el-table-column>
          <el-table-column
            prop="type_name"
            label="类型">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="创建人">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="日期">
          </el-table-column>
          <el-table-column label="操作" class="btn-container">
            <template slot-scope="scope" class="btn-container">
              <el-button
                class="edit-btn"
                @click="handleEdit(scope.row, scope.$index)">
                <i class="el-icon-edit-outline"></i>
                修改
                </el-button>
                <el-button
                class="delete-btn"
                @click="handleDelete(scope.$index, scope.row)">
                <i class="el-icon-delete"></i>
                删除
                </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加 规程管理 -->
    <el-dialog
      :title="ruleAdd.title"
      class="dialog-container"
      :visible.sync="dialogUpdate">
      <el-form class="form-container" :model="ruleAdd"  :rules="rules" ref="ruleAdd">
          <el-form-item class="input-list" label="规程代码" prop="code">
            <el-input type="text" placeholder="请输入规程代码" v-model="ruleAdd.code"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="规程名称" prop="name">
            <el-input type="text" placeholder="请输入规程名称" v-model="ruleAdd.name"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="类型" prop="type">
            <!-- <el-input type="password" placeholder="请输入密码" v-model="ruleAdd.password"></el-input> -->
            <el-select class="options-select" v-model="ruleAdd.type" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.device_type"
                :label="item.type_name"
                :value="item.device_type">
              </el-option>
            </el-select>
        </el-form-item>
<!--        <el-form-item class="input-list" label="提示">
            <span class="red-txt">您只能创建与您能力匹配的规程</span>
          </el-form-item>   -->
          <el-form-item class="btn-list">
            <el-button class="btn-save" @click="submitForm('ruleAdd')">保存</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 删除的弹窗框 start -->
    <delete-box @delete="deleteData" v-if="deleteShow"></delete-box>
    <!-- 删除的弹出框 end -->    
  </div>
</template>

<script type='text/ecmascript-6'>
import DeleteBox from 'components/DeleteBox.vue'
import { regulationsCode, regulationsName} from 'common/js/loginValidate'
/* import { getCookie } from 'common/js/mUtils.js' */
export default {
  data() {
    return {
      empty: '没有规程管理信息',
      page: 1,
      limit: 10,
      tableData: [],
      total: 0,
      dialogUpdate: false,
      ruleAdd: {}, // 修改规程管理
      rules: {
        code: [
          { validator: regulationsCode, trigger: ['blur'] }
        ],
        name: [
          { validator: regulationsName, trigger: 'blur'}
        ]
      },
      options: [],
      search_name: '',
      search_state: false,
      deleteShow: false,
      reType: ''
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    initData() {
      let that = this
      that.$api.getRules({
        page_num: (that.page - 1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.data.length > 0) {
          that.tableData = res.data.data
          that.total = Number(res.data.total)
        } else {
          that.tableData = []
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      if (this.search_state) {
        this.searchName()
      } else {
        this.initData()
      }
    },
    newOrder() {
      /* this.dialogUpdate = true */
      this.getType()
    },
    getType () {
      let that = this
      that.ruleAdd = {}
      this.$api.getAllDeviceType({
      }).then(res => {
        if (res.data.length > 0) {
          that.options = res.data
          that.dialogUpdate = true
          that.ruleAdd.type = res.data[0].device_type
          that.ruleAdd.title = '添加规程管理'
        } else {
          that.$message({
            type: 'error',
            message: '分类获取错误！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    // 新增规格保存
    submitForm(formName) { // 修改后 点击保存
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(that.ruleAdd.rule_id) {
            that.$api.updateRules({
              type: this.ruleAdd.type,
              name: this.ruleAdd.name,
              code: this.ruleAdd.code,
              rule_id: that.ruleAdd.rule_id
            }).then(res => {
              that.dialogUpdate = false
              if (res.data.msg === true) {
                that.$message({
                  type: 'success',
                  message: '规程管理修改成功！！',
                  customClass: 'msg-position',
                  showClose: true
                })
                /* 修改成功 */
                if (that.search_state) {
                  that.searchName()
                } else {
                  that.initData()
                }
                /* that.tableData[that.dataIndex].name = that.ruleAdd.name
                that.tableData[that.dataIndex].code = that.ruleAdd.code
                let arr = that.options.filter(item => {
                  return item.device_type == that.ruleAdd.type
                })
                that.tableData[that.dataIndex].type_name= arr[0].type_name */
              } else {
                that.$message({
                  type: 'error',
                  message: res.data.error,
                  customClass: 'msg-position',
                  showClose: true
                })
              }
            }).catch(err => {
              that.$message({
                type: 'error',
                message: err,
                customClass: 'msg-position',
                showClose: true
              })
            })
          } else {
            that.$api.addRules({
              type: this.ruleAdd.type,
              name: this.ruleAdd.name,
              code: this.ruleAdd.code
            }).then(res => {
              that.dialogUpdate = false
              if (res.data.msg === true) {
                that.$message({
                  type: 'success',
                  message: '规程管理添加成功！！',
                  customClass: 'msg-position',
                  showClose: true
                })
                that.initData()
              } else {
                that.$message({
                  type: 'error',
                  message: res.data.error,
                  customClass: 'msg-position',
                  showClose: true
                })
              }
            }).catch(err => {
              that.$message({
                type: 'error',
                message: err,
                customClass: 'msg-position',
                showClose: true
              })
            })
          }
        }
      })
    },
    // 修改 规格
    handleEdit (row, index) {
      let that = this
      that.ruleAdd = {}
      this.$api.getAllDeviceType({
      }).then(res => {
        if (res.data.length > 0) {
          that.options = res.data
          that.dialogUpdate = true
          that.dialogUpdate = true
          that.dataIndex = index
          that.ruleAdd = {
            title: '修改规程管理',
            code: row.code,
            name: row.name,
            type: row.device_type,
            rule_id: row.rule_id
          }
        } else {
          that.$message({
            type: 'error',
            message: '分类获取错误！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    handleDelete (index,row) { // 点击删除按钮
      let that = this
      that.deleteIndex = index
      that.deleteRow = row
      that.deleteShow = true
    },
    deleteData (val) { // 点击删除的弹出框
      let that = this
      if (val === 'cancle') {
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
      if (val === 'sure') {
        that.delete(that.deleteIndex, that.deleteRow.rule_id)
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
    },    
    delete(index,rule_id){
      let that = this
      this.$api.deleteRules({
        rule_id: rule_id
      }).then(res => {
        if (res.data.msg === true) {
          /* that.tableData.splice(index, 1)
          that.total = that.total - 1 */
          that.initData()
          that.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '删除失败',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })  
    },
    searchName () {// 搜索规程管理
      let that = this
      if (!that.search_name) {
        that.$message({
          type: 'error',
          message: `请输入搜索内容`,
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      if (!that.search_state) {
        that.search_state = true
        that.page = 1
      }
      that.$api.searchRule({
        search: that.search_name,
        page_num: (that.page - 1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.data.length > 0) {
          that.tableData = res.data.data
          that.total = Number(res.data.total)
        } else {
          /* this.tableData = []
          that.total = 0 */
          that.$message({
            type: 'error',
            message: `没有该规程信息`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    }
  },
  components: {
    DeleteBox
  }
}
</script>

<style  lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/mixin.styl'
@import '~common/stylus/box.styl'
</style>
